import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector:      'pagination-secondary',
  templateUrl: './pagination-secondary.component.html',
  host: { class: 'am-flex-align gap-s width-max-content' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PaginationSecondaryComponent {
  @Input() page:          number;
  @Input() totalPages:    number;
  @Input() total:         number;
  @Input() perPage:       number = 10;

  @Input() activeColor:   string = 'color-white';
  @Input() activeBgColor: string = 'bg-blue';
  @Output() callback = new EventEmitter<any>();
  constructor() {}

  get rangeStart(): number {
    return (this.page - 1) * this.perPage + 1;
  }

  get rangeEnd(): number {
    return Math.min(this.page * this.perPage, this.total);
  }

  previous(): void {
    if (this.page > 1) this.callback.emit(this.page - 1);
  }

  next(): void {
    if (this.page < this.totalPages) this.callback.emit(this.page + 1);
  }

  getPaginationButtons(): number[] {
    let buttons = [];
    if (this.totalPages >= 2 && this.totalPages <= 6) {
      for (let i = 1; i <= this.totalPages; i++) { buttons.push(i); }
      return buttons;
    } else if (this.totalPages >= 7) {
      if (this.page <= 4) for (let i = 1; i <= 5; i++) { buttons.push(i); }
      else if (this.page >= 5) buttons.push(1, '...');
      if (this.page >= 5 && this.page + 4 <= this.totalPages) {
        buttons.push(this.page - 1);
        buttons.push(this.page);
        buttons.push(this.page + 1);
      }
      if (this.page < 5  && this.page + 3 <= this.totalPages ||
          this.page >= 5 && this.page + 4 <= this.totalPages) buttons.push('...', this.totalPages);
      else if (this.page >= 5 && this.page + 4 >= this.totalPages) for (let k = 4; k >=0; k--) {
        buttons.push(this.totalPages - k);
      }
    }
    return buttons;
  }

  callbackHandler(page: number, index: number = null): void {
    let p = page;
    if (isNaN(page) && index !== null) {
      if (index === 1) p = Math.round(this.page / 2);
      else p = Math.round(this.page + (this.totalPages - this.page) / 2);
    }

    this.callback.emit(p);
  }

}
